import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';

import { DeleteZoneProps } from './DeleteZone.types';

export const DeleteZone = ({ zone, isModalOpen, isLoading, onModalClose, onSubmit }: DeleteZoneProps) => {
  const { formatMessage } = useLocale();

  // Deleting a zone also deletes every przejście it is the start or end zone of (contract §1, DELETE /strefa/:id).
  const hasPrzejscia = zone.liczbaPrzejsc > 0;

  return (
    <ActionModal
      header={formatMessage({ id: AppMessages['definitions.zones.delete.title'] })}
      open={isModalOpen}
      onClose={onModalClose}
      size="medium"
      onSubmit={onSubmit}
      isLoading={isLoading}
      submitButtonDisabled={isLoading}
      submitButtonText={formatMessage({ id: AppMessages['common.delete'] })}
    >
      <>
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['definitions.zones.delete.subtitle'] })} {zone.kod} {zone.nazwa}
        </ActionModal.Subtitle>
        {hasPrzejscia ? (
          <>
            <ActionModal.Text bold>
              {formatMessage({ id: AppMessages['definitions.zones.delete.przejscia.title'] })}
            </ActionModal.Text>
            <ActionModal.Text>
              {formatMessage({ id: AppMessages['definitions.zones.delete.przejscia.text'] })}
            </ActionModal.Text>
          </>
        ) : (
          <ActionModal.Text>{formatMessage({ id: AppMessages['definitions.zones.delete.text'] })}</ActionModal.Text>
        )}
      </>
    </ActionModal>
  );
};
